import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Renderer2,
  SecurityContext,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { WindowRefService } from 'i2g-ng-utils';

@Directive({
  selector: '[appFitText]',
})
export class FitTextDirective implements OnChanges {
  @Input() maxFontSize?: number | 'inherit' = Number.POSITIVE_INFINITY;
  @Input() innerHTML;

  private _el: HTMLElement;

  constructor(
    private _ref: ElementRef,
    private _renderer: Renderer2,
    private _sanitizer: DomSanitizer,
    private _window: WindowRefService,
    @Inject(DOCUMENT) private _document: Document
  ) {}

  @HostListener('window:resize')
  public onWindowResize = (): void => {
    this._fitText();
  };

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.innerHTML) {
      this._el = this._ref.nativeElement;
      const content = this._sanitizer.sanitize(
        SecurityContext.HTML,
        this.innerHTML
      );
      this._el.innerHTML = this._toHTML(content);
      this._fitText();
    }
  }

  private _toHTML(str) {
    return this._isHTML(str) ? str : `<div>${str}</div>`;
  }

  private _isHTML(str) {
    const div = this._document.createElement('div');
    div.innerHTML = str;
    return (
      div.childNodes.length === 1 && div.firstChild.nodeType !== Node.TEXT_NODE
    );
  }

  private _fitText() {
    this._el.style.visibility = 'hidden';
    setTimeout(() => {
      const style = this._window.nativeWindow.getComputedStyle(this._el);

      const parentWidth =
        this._el.clientWidth -
        parseFloat(style.paddingLeft) -
        parseFloat(style.paddingRight);
      const childWidth = this._getContentWidth(style.font);

      const ratio = parentWidth / childWidth;

      if (ratio < 1) {
        const offset = (parentWidth - childWidth) / 2;
        this._renderer.setStyle(
          this._el.firstChild,
          'transform',
          `scale(${ratio}) translateX(${offset}px)`
        );
      }
      this._el.style.visibility = '';
    });
  }

  private _getContentWidth(font) {
    const div = this._document.createElement('div');
    div.style.font = font;
    div.style.position = 'absolute';
    div.style.zIndex = '-10000';

    div.innerHTML = this._el.innerHTML;

    this._document.body.appendChild(div);
    const elWidth = div.clientWidth;
    this._document.body.removeChild(div);

    return elWidth;
  }
}
